import { truckingConstants } from '../../_constants';

export function truckings(state = {}, action) {
    switch (action.type) {
        case truckingConstants.TRUCKING_FETCHING:
            return {
                ...state,
                truckingFetching: true
            };
        case truckingConstants.TRUCKING_FETCHED:
            return {
                ...state,
                truckingFetching: false
            };
        case truckingConstants.TRUCKING_SUBMITTING:
            return {
                ...state,
                truckingSubmitting: true
            };
        case truckingConstants.TRUCKING_SUBMITTED:
            return {
                ...state,
                truckingSubmitting: false
            };
        case truckingConstants.GET_TRUCKINGS:
            return {
                ...state,
                truckings: action.truckings,
            };
        case truckingConstants.GET_TRUCKING_BY_ID:
            return {
                ...state,
                trucking: action.trucking
            };
        case truckingConstants.GET_AUTHORIZED_TRUCKING:
            return {
                ...state,
                authorizedTrucking: action.authorizedTrucking
            };
        case truckingConstants.TRUCKING_BY_BRANCH:
            return {
                ...state,
                truckingByBranch: action.truckingByBranch
            };
        case truckingConstants.GET_TRUCKING_FOR_TALLYSHEET:
            return {
                ...state,
                TruckingForTallySheet: action.TruckingForTallySheet
            };
        case truckingConstants.TRUCKING_FOR_ATW:
            return {
                ...state,
                truckingATW: action.truckingATW
            };
        case truckingConstants.TRUCKING_FOR_HUSTLING:
            return {
                ...state,
                hustlingTrucker: action.hustlingTrucker
            };
        case truckingConstants.TRUCKING_CTS_REPORT:
            return {
                ...state,
                truckingCTSReport: action.truckingCTSReport
            };
        case truckingConstants.GET_TRUCKING_ALL:
            return {
                ...state,
                truckingData: action.truckingData
            };
        default:
            return state;
    }
}